import { Role } from '../interfaces/rolesEnum'

export const ROLE_PERMISSION: Record<string, string[]> = {
  // All
  '/dashboard': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
    Role.PROMOTER_MANAGER,
    Role.SELLER,
    Role.PROMOTER,
  ],
  '/reports/:id': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
    Role.PROMOTER_MANAGER,
    Role.SELLER,
    Role.PROMOTER,
  ],
  '/profile': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
    Role.PROMOTER_MANAGER,
    Role.SELLER,
    Role.PROMOTER,
  ],
  '/terms': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
    Role.PROMOTER_MANAGER,
    Role.SELLER,
    Role.PROMOTER,
  ],

  // Limited
  '/logs': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
  ],
  '/reports': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
  ],
  '/users': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.PROMOTER_MANAGER,
  ],
  '/stores': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.PROMOTER_MANAGER,
  ],
  '/promoters-companies': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
  ],
  '/products': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
  ],
  '/trade-marketing-daily-check': [
    Role.ROOT,
    Role.ADMIN,
    Role.OBSERVER,
    Role.SUPERVISOR,
    Role.TRADE_MARKETING_COORDINATOR,
  ],
}

export const ROUTE_PATTERNS = Object.keys(ROLE_PERMISSION).map(path => ({ path }))
